import request from '@/utils/request'

// 获取个人信息
export function getUserInfo(userId){
  return request.get('/api/user/'+userId)
}



export function updateUserInfo(data,userId) {
  return request({
    url: '/api/user/'+userId,
    method: 'post',
    data: data,
  })
}

// 获取账户信息
export function getOfficialAccountInfo(){
  return request.get('/api/account/officialAccountInfo')
}

// 获取账户信息
export function getOfficialSupperAccountInfo(userId){
  return request({
    url: '/api/account/officialAccountInfo',
    method: 'get',
    params: {
      userId
    }
  })
}

// 获取账户信息
export function getOfficialWaitExamine(){
  return request.get('/api/user/officialWaitExamine')
}


